<template>
    <login-layout>
        <form class="form-horizontal m-t-20" novalidate @submit.prevent="reset()">
            <div class="m_b_5 form-group ">
                <div class="col-xs-12" :class="{'has-error': errors['email']}">
                    <input class="custom_input form-control" v-model="record.email" type="email" autocomplete="false" :placeholder="$t('type_your_email')" v-pml-focus>
                    <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                </div>
            </div>
            <div class="m_b_5 form-group ">
                <div class="col-xs-12" :class="{'has-error': errors['password']}">
                    <input class="custom_input form-control" v-model="record.password" type="password" :placeholder="$t('choose_a_password')">
                    <span class="error" v-if="errors['password']">{{ errors['password'][0] }}</span>
                </div>
            </div>
            <div class="m_b_5 form-group ">
                <div class="col-xs-12" :class="{'has-error': errors['password_confirmation']}">
                    <input class="custom_input form-control" v-model="record.password_confirmation" type="password" :placeholder="$t('confirm_your_password')">
                    <span class="error" v-if="errors['password_confirmation']">{{ errors['password_confirmation'][0] }}</span>
                </div>
            </div>
            <div class="form-group text-center m-t-20">
                <div class="col-xs-12">
                    <button class="btn_login btn btn-block text-uppercase waves-light" type="submit" v-pml-block="isLoading">{{ $t('account_activate') }}</button>
                </div>
            </div>
            <div class="form-group ">
                <div class="col-xs-12 t_right">
                    <router-link :to="{ name: 'auth.login' }" class="link_login">
                        <i class="fa fa-mail-reply m-r-5"></i> {{ $t('login') }}
                    </router-link>
                </div>
            </div>
        </form>
    </login-layout>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { memberActivate } from 'services/auth'
    import { mapActions } from 'vuex'

    export default {
        name: 'MemberActivate',
        data () {
            return {
                record: {},
                errors: [],
                isLoading: false
            }
        },
        created () {
            this.logout()
            this.record.token = this.$route.params.token
        },
        methods: {
            ...mapActions([ 'logout' ]),
            reset () {
                this.isLoading = true

                memberActivate(this.record)
                    .then(() => {
                        Notify.success(trans('your_account_has_been_activated'))
                        this.$router.push({ name: 'auth.login' })
                    })
                    .catch(error => { this.errors = (typeof error.response.data.errors === 'undefined') ? [] : error.response.data.errors })
                    .then(() => { this.isLoading = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/auth/components/MemberActivate.vue